import strings from 'strings';

export const FORM_FIELDS_MAP = {
  CallType: {
    key: 'callType',
    paramKey: 'callTypeId',
    inboundAccesor: ({ callType }) => (callType ? String(callType?.id) : null)
  },
  Status: {
    key: 'status',
    paramKey: 'statusId',
    inboundAccesor: 'status.id'
  },
  Outcome: {
    key: 'outcome',
    paramKey: 'outcomeId',
    outboundAccesor: 'id',
    inboundAccesor: 'outcome'
  },
  CustomOutcome: {
    key: 'customOutcome'
  },
  Comments: {
    key: 'comment'
  }
};

export const CALL_TYPES_RADIO_OPTIONS = [
  {
    id: 1,
    label: strings.dailyPlan.callTypes.liveCall
  },
  {
    id: 2,
    label: strings.dailyPlan.callTypes.voicemail
  },
  {
    id: 3,
    label: strings.dailyPlan.callTypes.unableToConnect
  }
];
